import React from "react";
import poster from "../../img/poster.png";
import "./HomePage.css";
const HomePage = () => {
  return (
    <>
      <section className="lg:pb-3 bg-gray-800 lg:h-screen">
        <div className="relative container px-4 mx-auto">
          <div className="flex flex-wrap items-center -mx-4 2xl:mb-14">
            <div className="w-full lg:ml-4 lg:w-1/2 px-4 mb-16 lg:mb-0">
              <h2 className="max-w-2xl mt-12 mb-12 text-6xl 2xl:text-8xl text-white font-bold font-heading">
                Pen down your strategies{" "}
                <span className="text-yellow-500">By creating a post</span>
              </h2>
              <section
                className="mb-12 lg:mb-16 2xl:mb-24 text-xl text-red-100 font-bold italic
                 before:bg-pink-500"
              >
                <section className="before:block before:absolute before:-inset-1 before:bg-green-500 relative inline-block ">
                  <p className="relative text-white line">
                    {" "}
                    #Let's Make Money Together
                  </p>
                </section>
              </section>
            </div>
            <div className="w-full lg:w-auto px-4 lg:mx-auto">
              <img
                className="w-full animate-bounce"
                src={poster}
                alt={poster}
              />
            </div>
          </div>
        </div>
      </section>
      <footer className="px-4 bg-white-800">
          <div className="py-6 select-none font-medium xl:text-xl lg:text-lg text-sm md:text-xl font-mono text-center text-black-400">
             Made with ❤️ by Vincent Raja
          </div>
        </footer>
    </>
  );
};

export default HomePage;
